const paginationConfig = {
  paginationLimitNum: 10,
  paginationLimitNumSmall: 5,
};

export default paginationConfig;
